// extracted by mini-css-extract-plugin
export default {"imageWrapper":"oM-z","twoColumnImage":"pM-z"};